import React, { useState, useEffect } from 'react';
import axios from 'axios';
import useMediaQuery from '@mui/material/useMediaQuery';
import LoadingComponent from '../../components/LoadingComponent';

import { ThemeProvider } from '@mui/material/styles';
import { createNewTheme } from '../../functions/utils';
import { Box, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, List, ListItem, ListItemButton, ListItemText, TextField, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles';
import { Alert } from '@mui/material';
import { ContentPaste, DragIndicator, PhoneOutlined, WhatsApp } from '@mui/icons-material';
import { SpacerGustio } from '../../components/DesignSystem/SpacerGustio';
import { ButtonGustio } from '../../components/DesignSystem/ButtonGustio';

function Suporte({ onChange, update, colorPrimary, colorSecondary, colorTertiary }, props) {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [tipoSuporte, setTipoSuporte] = useState(0);
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [termos, setTermos] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [loading, setLoading] = useState(false);
  const [scroll] = useState('paper');

  const handleOpenLoading = () => {
    setLoading(true);
  };

  const handleCloseLoading = () => {
    setLoading(false);
  };

  const handleSuporteChange = (event, newValue) => {
    setTipoSuporte(newValue);
  };

  const handleSelectTerms = (terms) => {
    setTermos(terms);
  };

  const handleNome = (event) => {
    setNome(event.target.value);
  };

  const handleMensagem = (event) => {
    setMensagem(event.target.value);
  };

  const handleEmail = () => {
    handleOpenLoading()
    if (!nome) {
      handleCloseLoading()
      update("", `${Date.now()}___error___Por favor preencha seu nome.`)
      return
    }
    if (!mensagem) {
      handleCloseLoading()
      update("", `${Date.now()}___error___Por favor preencha a mensagem com sua dúvida para nosso suporte entrar em contato.`)
      return
    }
    const post_url = "https://gerenciador.gustio.com.br/api/suporte-email.php";
    const json = JSON.stringify({
      nome: nome,
      email: email,
      mensagem: mensagem
    });

    axios.post(post_url, json)
      .then(resp => {
        const response = resp.data
        if (response) {
          if (response.resposta === "success") {
            handleCloseLoading()
            update("", `${Date.now()}___success___Sua solicitação de suporte foi enviada com sucesso.`)
            setMensagem("")
            setNome("")
            return
          }
        }
        handleCloseLoading()
        update("", `${Date.now()}___error___Não foi possivel enviar a sua solicitação de suporte. Por favor verifique sua conexão e tente novamente.`)
      })
      .catch(error => {
        handleCloseLoading()
        update("", `${Date.now()}___error___Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente.`)
      });

  };

  const copyToClipboard = (text) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text)
        .then(() => {
          update("", `${Date.now()}___success___Número copiado com sucesso.`)
        })
        .catch(error => {
          update("", `${Date.now()}___error___Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente.`)
        });
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        update("", `${Date.now()}___success___Número copiado com sucesso.`)
      } catch (err) {
        update("", `${Date.now()}___error___Não foi possivel copiar o número`)
      }
      document.body.removeChild(textArea);
    }
  }

  const handleCopy = (text) => {
    copyToClipboard(text)
  };

  const handleWhatsapp = (text) => {
    window.open(`https://wa.me/55${text}?text=Olá,%20preciso%20de%20ajuda%20com%20o%20gustio!`, '_blank');
    copyToClipboard(text)
  };

  useEffect(() => {
    const email = localStorage.getItem('emEst');
    setEmail(email)
  }, []);

  return (
    <ThemeProvider theme={createNewTheme(colorPrimary, colorSecondary, colorTertiary)}>
      <LoadingComponent open={loading} />
      <Box style={{ top: 75, bottom: 0, right: 0, left: isMobile ? 0 : 80, position: "absolute" }}>
        <Alert
          variant="outlined"
          severity="info"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'left',
            color: "#464545", fontSize: 14,
            border: "none",
            background: "#ECF0F9"
          }}
        >
          <Box>
            <b style={{ fontSize: 16 }}>Horário de funcionamento</b><br />
            Todos os dias das 07h00 às 19h00
          </Box>
        </Alert>

        <Box style={{ height: "22px" }} />

        <Dialog
          open={termos === "2"}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" style={{ display: "flex", alignItems: "center", fontSize: 18, fontWeight: '600' }}>
            <ContentPaste /> &nbsp;
            Termos de Uso
          </DialogTitle>
          <DialogContent dividers={scroll === 'paper'}>
            <DialogContentText
              id="scroll-dialog-description"
              tabIndex={-1}
            >
              <b>VERSÃO BETA DO Sistema GUSTIO COM MEIO DE PAGAMENTO ONLINE</b><br /><br />
              Este Termo de Uso regula a utilização da funcionalidade de <b>pagamento online</b>, atualmente em <b>versão beta</b>, disponibilizada pela empresa Elysoftech no Sistema GUSTIO de delivery e cardápio digital.
              <br /><br />
              <b>1. Aceitação do Termo</b><br /><br />
              Ao utilizar a funcionalidade de pagamento online, o usuário declara estar ciente de que se trata de uma versão beta, disponibilizada com o propósito de testes e aprimoramento, podendo apresentar falhas, instabilidades ou limitações de funcionamento.<br /><br />
              <b>2. Natureza da Versão Beta</b><br /><br />
              A versão beta está em <b>fase experimental</b>, com o objetivo de coletar feedbacks reais de uso e detectar eventuais problemas técnicos. A funcionalidade ainda <b>não representa a versão final ou oficial do sistema.</b><br /><br />
              <b>3. Riscos e Responsabilidades</b> O usuário compreende e concorda que:<br /><br />
              - Podem ocorrer <b>erros técnicos</b>erros técnicos, instabilidades, falhas de comunicação, indisponibilidades temporárias ou problemas no processamento de pagamentos;<br /><br />
              - A equipe da Elysoftech estará <b>disponível para suporte e correção de eventuais falhas</b> identificadas durante o uso;<br /><br />
              - A Elysoftech <b>não se responsabiliza por quaisquer perdas, prejuízos ou danos,</b> diretos ou indiretos, que possam ocorrer devido ao uso da versão beta;<br /><br />
              - O uso desta funcionalidade é feito <b>por livre e espontânea vontade,</b> com total ciência de que se trata de uma versão ainda em desenvolvimento.<br /><br />
              <b>4. Suporte e Contato</b><br /><br />
              Em caso de dúvidas, falhas ou sugestões durante o uso da versão beta, o usuário poderá entrar em contato diretamente com nosso representante comercial:<br /><br />
              <b>(11) 99562-8903<br />
                Elysoftech – Suporte Comercial</b><br /><br />
              <b>5. Consentimento</b> <br /><br />Ao utilizar a funcionalidade de pagamento online da Elysoftech nesta fase beta, o usuário declara que <b>leu, compreendeu e aceita integralmente os termos acima descritos,</b> assumindo total responsabilidade pelo uso consciente da ferramenta.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ButtonGustio fullWidth={false} onClick={() => setTermos(null)}>Fechar</ButtonGustio>
          </DialogActions>
        </Dialog>

        <Dialog
          open={termos === "1"}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" style={{ display: "flex", alignItems: "center", fontSize: 18, fontWeight: '600' }}>
            <ContentPaste /> &nbsp;
            Termo de contratação
          </DialogTitle>
          <DialogContent dividers={scroll === 'paper'}>
            <DialogContentText
              id="scroll-dialog-description"
              tabIndex={-1}
            >
              <b>TERMO DE ADESÃO - GUSTIO</b><br /><br />
              <b>CONTRATADO (A):</b>
              As partes identificadas na seção de identificação deste contrato, sendo o CONTRATANTE,
              que solicita os serviços, e o CONTRATADO(A), que oferece os serviços de tecnologia, têm
              entre si justo e acertado o presente Contrato de Prestação de Serviços de Tecnologia. Este
              contrato é regido pelas disposições do Código Civil Brasileiro, especificamente nos artigos
              421, 422, 425, 594 e 598 do Código Civil Brasileiro, bem como no princípio do pacta sunt
              servanda e na Lei 13.429/17 (Lei da Terceirização), pelas cláusulas, condições de preço,
              forma e termo de pagamento descritas no presente.<br /><br />
              <b>DO OBJETO DO CONTRATO:</b><br /><br />
              <b>CLÁUSULA 1ª.</b> Constitui objeto do presente contrato a prestação de serviços de tecnologia,
              sem exclusividade pelo profissional prestador, cujo atendimento será realizado na sede da
              contratante somente quando necessário e indispensável o seu comparecimento, podendo
              este prestá-lo em qualquer lugar contanto que atingida a finalidade deste contrato, podendo,
              inclusive, se dar como home office.<br /><br />
              <b>DAS OBRIGAÇÕES DO (A) CONTRATADO (A)</b><br /><br />
              <b>CLÁUSULA 2ª.</b> São deveres do (a) CONTRATADO (A):
              Cumprir integralmente o disposto neste contrato;
              Utilizar técnicas condizentes com os serviços, efetuando todos os esforços para a sua
              consecução;
              Prestar contas, quando julgar necessário, à CONTRATANTE sobre suas atividades
              realizadas;<br /><br />
              <b>DAS OBRIGAÇÕES DA CONTRATANTE</b><br /><br />
              <b>CLÁUSULA 3ª.</b> São deveres da CONTRATANTE:
              Realizar o pagamento, conforme disposto na cláusula 5ª deste contrato;
              Zelar para que a CONTRATADA tenha à sua disposição todas as informações necessárias
              para as elaborações dos materiais que serão veiculados na ferramenta, e demais utilizados
              para obtenção do êxito da publicidade;
              Fica vedado à CONTRATANTE negociar abatimentos, descontos ou dilações de prazo para
              o pagamento ou execução dos serviços, sem o prévio conhecimento e autorização da
              contratada;
              Tratar o profissional com respeito, discrição, profissionalismo, lhe dando todo o suporte e
              liberdade dispostos nesse instrumento contratual;
              Informar previamente à CONTRATADA sobre toda e qualquer anormalidade que possa
              influir no sistema.<br /><br />
              <b>DO PAGAMENTO DOS SERVIÇOS</b><br /><br />
              <b>CLÁUSULA 4ª.</b> Pelo desempenho das atividades dispostas no contrato, a CONTRATADA
              receberá o valor condizente com o plano contratado, podendo ser:<br />
              <b>Plano Básico</b> de R$ 24,90 (vinte e quatro reais e noventa centavos) mensais referente aos
              serviços prestados.<br />
              <b>Plano Padrão</b> de R$ 29,90 (vinte nove reais e noventa centavos) mensais referente aos
              serviços prestados.<br />
              <b>Plano Profissional</b> de R$ 59,90 (cinquenta e nove reais e noventa centavos) mensais
              referente aos serviços prestados.<br />
              <b>PARÁGRAFO 1º:</b> O pagamento do valor acordado se dará através de PIX, TED ou até
              mesmo BOLETO até o dia do início da ativação do serviço de cada mês.<br /><br />
              <b>DA DURAÇÃO DO CONTRATO</b><br /><br />
              <b>CLÁUSULA 5ª.</b> O presente Contrato tem duração de 3 (três) meses, prorrogáveis
              automaticamente por período de 30 dias, sendo que, caso uma das partes não tenha
              interesse na prorrogação, deverá informar a outra parte com antecedência mínima de 30
              dias da prorrogação.<br />
              <b>Parágrafo único:</b> O presente Contrato poderá ser renovado até um prazo máximo de 2
              anos, passando após tal período para Contrato por tempo indeterminado, sendo
              desnecessária sua renovação anual, conforme preceitua a Lei n.º 9.601/98.<br /><br />
              <b>DA RESCISÃO:</b><br /><br />
              <b>Cláusula 6ª.</b> A violação de qualquer cláusula disposta neste presente instrumento rescinde
              automaticamente o presente instrumento, sendo imposta multa contratual no valor de 100%
              do período remanescente, em benefício da parte inocente, sem prejuízo de perdas e danos,
              bem como custos gerados na cobrança, se forem necessários, independente do lapso
              temporal do contrato firmado a parte que deu causa.<br /><br />
              <b>DA RESILIÇÃO:</b><br /><br />
              <b>Cláusula 7ª.</b> As partes poderão requerer a resilição do contrato a qualquer tempo, sem
              necessidade de pagamento de multas, desde que comunique sua vontade à outra parte
              com antecedência mínima de 20 (vinte) dias e desde que tenha cumprido o período de
              fidelidade de 03 meses. E o descumprimento poderá gerar uma multa rescisória equivalente
              ao valor total do contrato, além de custos extras decorrentes da quebra de contrato. E o não
              pagamento poderá acarretar inclusão aos órgãos de proteção ao crédito.<br />
              <b>Cláusula 8ª:</b> As partes concordam que, após rescisão contratual, independente da
              motivação, nenhuma das partes poderá utilizar a imagem da outra parte, seja pessoal, da
              marca, do estabelecimento, e afins, para fins publicitários, após a rescisão
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ButtonGustio fullWidth={false} onClick={() => setTermos(null)}>Fechar</ButtonGustio>
          </DialogActions>
        </Dialog>

        <Grid container spacing={2} style={{ padding: 16 }}>
          <Grid item xs={12} sm={12} md={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography style={{ fontWeight: "bold", color: "#1B1B1B" }}>Suporte</Typography>
                <Typography style={{ fontWeight: "400", fontSize: 14, color: "#1B1B1B" }}>Entre em contato em um de nossos canais abaixo. Veja também nossos termos de uso</Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <Grid container spacing={0}>
                  <Grid item xs={12} sm={12} md={3}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <List>
                          <ListItem disablePadding style={{ backgroundColor: tipoSuporte === 0 ? "#F2F2F2" : "" }} onClick={(event) => handleSuporteChange(event, 0)}>
                            <ListItemButton>
                              <ListItemText primary={<Typography style={{ display: "flex" }}><DragIndicator />&nbsp;&nbsp;&nbsp;E-mail</Typography>} primaryTypographyProps={{ fontWeight: "bold" }} />
                            </ListItemButton>
                          </ListItem>
                          <Divider />
                          <ListItem disablePadding style={{ backgroundColor: tipoSuporte === 1 ? "#F2F2F2" : "" }} onClick={(event) => handleSuporteChange(event, 1)}>
                            <ListItemButton>
                              <ListItemText primary={<Typography style={{ display: "flex" }}><DragIndicator />&nbsp;&nbsp;&nbsp;Telefone</Typography>} primaryTypographyProps={{ fontWeight: "bold" }} />
                            </ListItemButton>
                          </ListItem>
                          <Divider />
                          <ListItem disablePadding style={{ backgroundColor: tipoSuporte === 2 ? "#F2F2F2" : "" }} onClick={(event) => handleSuporteChange(event, 2)}>
                            <ListItemButton>
                              <ListItemText primary={<Typography style={{ display: "flex" }}><DragIndicator />&nbsp;&nbsp;&nbsp;Whatsapp</Typography>} primaryTypographyProps={{ fontWeight: "bold" }} />
                            </ListItemButton>
                          </ListItem>
                          <Divider />
                          <ListItem disablePadding onClick={(event) => handleSelectTerms("1")}>
                            <ListItemButton>
                              <ListItemText primary={<Typography style={{ display: "flex" }}><ContentPaste />&nbsp;&nbsp;&nbsp;Termos de Uso</Typography>} primaryTypographyProps={{ fontWeight: "bold" }} />
                            </ListItemButton>
                          </ListItem>
                          <Divider />
                          {localStorage.getItem("BTMd") === "A" &&
                            <>
                              <ListItem disablePadding onClick={(event) => handleSelectTerms("2")}>
                                <ListItemButton>
                                  <ListItemText primary={<Typography style={{ display: "flex" }}><ContentPaste />&nbsp;&nbsp;&nbsp;Termos de Uso BETA</Typography>} primaryTypographyProps={{ fontWeight: "bold" }} />
                                </ListItemButton>
                              </ListItem>
                              <Divider />
                            </>
                          }
                          {/* <ListItem disablePadding style={{ backgroundColor: tipoSuporte === 3 ? "#F2F2F2" : "" }} onClick={(event) => handleSuporteChange(event, 3)}>
                            <ListItemButton>
                              <ListItemText primary={<Typography><DragIndicator />Chat online</Typography>} primaryTypographyProps={{ fontWeight: "bold" }} />
                            </ListItemButton>
                          </ListItem>
                          <Divider /> */}
                        </List>

                      </Grid>
                    </Grid>
                  </Grid>
                  {tipoSuporte === 0 &&
                    <Grid item xs={12} sm={12} md={9} style={{ paddingLeft: isMobile ? 0 : 16, paddingTop: isMobile ? 16 : 0 }}>

                      <Typography style={{ textAlign: "left", fontSize: "14px", fontWeight: "600" }}>
                        Nome <b style={{ color: "#A51D1D" }}>*</b>
                      </Typography>
                      <SpacerGustio height={4} />
                      <TextField
                        fullWidth
                        hiddenLabel
                        value={nome}
                        onChange={handleNome}
                        variant="outlined"
                        size="large"
                        placeholder="Digite aqui seu nome"
                        type="text"
                      />

                      <SpacerGustio height={18} />

                      <Typography style={{ textAlign: "left", fontSize: "14px", fontWeight: "600" }}>
                        E-mail <b style={{ color: "#A51D1D" }}>*</b>
                      </Typography>
                      <SpacerGustio height={4} />
                      <TextField
                        fullWidth
                        hiddenLabel
                        value={email}
                        disabled
                        style={{ background: "#f2f2f2" }}
                        variant="outlined"
                        size="large"
                        placeholder="Digite aqui seu e-mail"
                        type="text"
                      />

                      <SpacerGustio height={18} />


                      <Typography style={{ textAlign: "left", fontSize: "14px", fontWeight: "600" }}>
                        Mensagem <b style={{ color: "#A51D1D" }}>*</b>
                      </Typography>
                      <SpacerGustio height={4} />
                      <TextField
                        fullWidth
                        hiddenLabel
                        value={mensagem}
                        onChange={handleMensagem}
                        variant="outlined"
                        size="large"
                        inputProps={{ maxLength: 140 }}
                        placeholder="Digite aqui sua mensagem"
                        type="text"
                        multiline
                        rows={4}
                      />

                      <SpacerGustio height={30} />

                      <ButtonGustio onClick={handleEmail}>
                        Enviar
                      </ButtonGustio>

                    </Grid>
                  }

                  {tipoSuporte === 1 &&
                    <Grid item xs={12} sm={12} md={9} style={{ paddingLeft: isMobile ? 0 : 16, paddingTop: 8 }}>
                      <Card variant="outlined" sx={{ borderRadius: "8px" }}>
                        <CardHeader
                          title={<Typography style={{ display: "flex" }}><PhoneOutlined /> &nbsp;&nbsp; Telefone</Typography>}
                          style={{ borderBottom: "solid #DCDBDB 1px", background: "#F2F2F2" }}
                        />
                        <CardContent>
                          <Typography style={{ fontSize: 16 }}>
                            Entre em contato com um de nossos números abaixo
                          </Typography>

                          <SpacerGustio height={10} />
                          <ButtonGustio onClick={() => handleCopy("11994247794")} fullWidth={isMobile} startIcon={<PhoneOutlined />}>
                            (11) 99424-7794
                          </ButtonGustio>
                          {isMobile && <SpacerGustio height={10} />}

                          <ButtonGustio onClick={() => handleCopy("11989006387")} fullWidth={isMobile} style={{ marginLeft: isMobile ? 0 : 16 }} startIcon={<PhoneOutlined />}>
                            (11) 98900-6387
                          </ButtonGustio>

                        </CardContent>
                      </Card>
                    </Grid>
                  }

                  {tipoSuporte === 2 &&
                    <Grid item xs={12} sm={12} md={9} style={{ paddingLeft: 16, paddingTop: 8 }}>
                      <Card variant="outlined" sx={{ borderRadius: "8px" }}>
                        <CardHeader
                          title={<Typography style={{ display: "flex" }}><WhatsApp /> &nbsp;&nbsp; Whatsapp</Typography>}
                          style={{ borderBottom: "solid #DCDBDB 1px", background: "#F2F2F2" }}
                        />
                        <CardContent>
                          <Typography style={{ fontSize: 16 }}>
                            Entre em contato diretamente pelo nosso Whatsapp
                          </Typography>

                          <SpacerGustio height={10} />
                          <ButtonGustio onClick={() => handleWhatsapp("11994247794")} startIcon={<WhatsApp />}>
                            (11) 99424-7794
                          </ButtonGustio>

                        </CardContent>
                      </Card>
                    </Grid>
                  }
                </Grid>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </Box>

    </ThemeProvider>
  );
}

export default Suporte;